import React, { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import getCourse from 'modules/Course/actionCreators';
import { RootState } from 'store/rootReducer';
import { ApiCallStatus } from 'store/statesHelper';
import SlicesRenderer from 'modules/_shared/components/SlicesRenderer';
import PageLoading from 'modules/_shared/ui-components/PageLoading';
import ErrorBlockComponent from '../../modules/_shared/ui-components/FailureComponent';
import Styled from './styled';

const Course: FunctionComponent = () => {
  const { uid } = useParams<{ uid: string }>();
  const { data, status } = useSelector<RootState, RootState['coursePage']>(
    (state) => state.coursePage
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCourse(uid));
  }, [dispatch, uid]);

  return (
    <>
      {status === ApiCallStatus.LOADING && <PageLoading />}
      {status === ApiCallStatus.SUCCESS && (
        <Styled.CourseWrapper>
          <SlicesRenderer slices={data!.slices} />
        </Styled.CourseWrapper>
      )}
      {status === ApiCallStatus.FAILURE && (
        <ErrorBlockComponent>
          <p>Something went wrong, course was not found</p>
        </ErrorBlockComponent>
      )}
    </>
  );
};

export default Course;
